// extracted by mini-css-extract-plugin
export default {"baseIllustration":"styles-module__baseIllustration__ee8833498f600d95de7c"};